<div class="dialog-main d-flex flex-column">
  <div class="header mt-2 mb-3">
    <h2 class="modal-title text-center question">
      <b>
        {{ title }}
      </b>
      <button type="button" class="close" (click)="rejectDialog()">
        <span> <img src="/assets/svg/ico-cross.svg" /> </span>
      </button>
    </h2>
  </div>

  <div
    class="rounded-top body-container d-flex flex-column align-items-center justify-content-start"
  >
    <div class="message w-100 h-100 mb-auto">
      <div class="my-5 mx-4">
        <div
          class="w-100 h-100 d-flex flex-column justify-content-center align-items-center"
        >
          <p class="row question text-center mb-4 text-break">
            {{ subTitle }}
          </p>

          <p class="message text-center mb-4 overflow-auto col-12 text-break">
            {{ bodyText }}
          </p>
          <p class="message text-center">
            {{ footerText }}
          </p>
        </div>
      </div>
    </div>
    <div class="message w-100 h-100">
      <div>
        <!-- code is comment due to the removel of "Step by Step Guide" in details screen in MPC-8655  -->
        <!-- <div
          class="w-100 h-100 d-flex flex-column justify-content-center align-items-center"
        >
          <p class="question text-center">
            {{ 'NEED_HELP' | translate }}
          </p>

          <p class="message text-center">
            {{ 'READ_OUR' | translate }}
            <a href="#" class="no-link-style">{{
              LANG_CONST.STEP_BY_STEP_GUIDE
            }}</a>
          </p>
        </div> -->
      </div>
    </div>
  </div>

  <div class="row my-2">
    <div class="col-12 my-1">
      <button
        class="btn btn-danger px-3 w-100 done-btn"
        type="button"
        (click)="acceptDialog()"
      >
        {{ 'DONE' | translate }}
      </button>
    </div>
  </div>
</div>
